var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FFCFCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55322 51.9533C14.1594 45.3331 21.8236 41 30.4998 41C38.9253 41 46.3965 45.0863 51.0395 51.3853C45.6248 56.713 38.1962 60 29.9998 60C22.0988 60 14.9111 56.9456 9.55322 51.9533Z",
    fill: "#FF3844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5564 13C34.3692 16.6355 37.3645 19.6308 41 19.4436C38.3006 21.8833 38.3006 26.1167 41 28.5564C37.3645 28.3692 34.3692 31.3645 34.5564 35C32.1167 32.3006 27.8833 32.3006 25.4436 35C25.6308 31.3645 22.6355 28.3692 19 28.5564C21.6994 26.1167 21.6994 21.8833 19 19.4436C22.6355 19.6308 25.6308 16.6355 25.4436 13C27.8773 15.6994 32.1167 15.6994 34.5564 13Z",
    fill: "#FF3844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoRock);
export default __webpack_public_path__ + "static/media/user-logo-rock.92727ac5f688dc247f94b8b115db6c7e.svg";
export { ForwardRef as ReactComponent };